export const projectColors = ['#A259FF', '#F24E1E', '#FFC107', '#6497B1'];
